module.exports = __webpack_public_path__ + "static/media/Team 7 Keeper AI Logo - Naemat Brar.4f4eabcd.png";